import { createSlice } from '@reduxjs/toolkit'
import { APP_NAME } from '../static/config'

export const retrieveInitialAuthState = () => {
  const $storage = JSON.parse(localStorage.getItem(APP_NAME))

  if ($storage && $storage.access_token) {
    return {
      isLoggedIn: true,
      token: $storage.access_token
    }
  }
  return {
    isLoggedIn: false,
    access_token: null,
    refresh_token: null
  }
}

const initialState = retrieveInitialAuthState()

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login (state, action) {
      const $storage = {
        access_token: action.payload.access_token,
        refresh_token: action.payload.refresh_token
      }

      state.isLoggedIn = true
      state.access_token = $storage.access_token
      state.refresh_token = $storage.refresh_token
      localStorage.setItem(APP_NAME, JSON.stringify($storage))
    },
    refresh (state, action) {
      const $storage = {
        access_token: action.payload.access_token
      }

      state.isLoggedIn = true
      state.access_token = $storage.access_token
      state.refresh_token = null
      localStorage.setItem(APP_NAME, JSON.stringify($storage))
    },
    logout (state) {
      state.isLoggedIn = false
      state.access_token = null
      state.refresh_token = null
      localStorage.removeItem(APP_NAME)
    }
  }
})

export default authSlice.reducer
export const authActions = authSlice.actions
